// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1z_H_","amount":"Amount_amount__1zpVp","tip":"Amount_tip__2NIIP","tipHeader":"Amount_tipHeader__t9u6_","tipsWrap":"Amount_tipsWrap__2_vx-"};